import type { RouterConfig } from '@nuxt/schema'

// https://router.vuejs.org/api/#routeroptions
export default <RouterConfig>{
    scrollBehavior(to, from, savedPosition) {

        return new Promise(async (resolve, reject) => {
            if (to && to.hash) {
                if (to.path == from.path) {
                    const el = document.querySelector(to.hash)
                    resolve({
                        top: el ? (el as HTMLElement).offsetTop : 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                } else {
                    setTimeout(() => {
                        const el = document.querySelector(to.hash)
                        resolve({
                            top: el ? (el as HTMLElement).offsetTop : 0,
                            left: 0,
                            behavior: 'smooth'
                        })
                    }, 400)
                }
            }
            else if (to.meta?.scrollPos && typeof to.meta.scrollPos === 'object' && 'top' in to.meta.scrollPos) {
                const y = (to.meta.scrollPos as { top: number }).top
                setTimeout(() => { resolve({ left: 0, top: y }) }, 400)
            }
            else if (savedPosition) {
                setTimeout(() => { resolve(savedPosition) }, 400)
            }
            else {
                setTimeout(() => { resolve({ left: 0, top: 0 }) }, 400)
            }
        })
    },
}